module.exports = __webpack_public_path__ + "img/035-smartphone.a71ee0a1.svg";